import styled from 'styled-components'

/* No DS TextButton has a destructive colour (Q-7), so the danger cue stays
   local; the disabled state comes from the native attribute. */
export const ClearAllButtonStyled = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  color: ${(props) => props.theme.colors.danger};

  &:disabled {
    cursor: default;
    color: ${(props) => props.theme.colors.text.secondary};
  }
`
